import React from "react";
import MainMenu from "./MainMenu";
import SaveMenu from "./saves/SaveMenu";
import WifeStat from "../Story/features/WifeStat";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import {useDispatch, useSelector} from "react-redux";

import {setDialogContent} from "../app/projectSlice";

const Dialog = () => {
    const dispatch = useDispatch();
    const dialog = useSelector(state => state.project.dialog);

    const close = () => {
        dispatch(setDialogContent(null));
    }

    const isMobile = () => (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) <= 992);

    const onBeforeOpen = (args) => {
        if (isMobile())
            args.maxHeight = "100vh"
        else
            args.maxHeight = "80vh"
    };

    const getContent = () => {
        let content;
        const style = {};
        // let style = {height: isMobile() ? "100vh" : "60em"};
        if (dialog.content === "mainMenu")
            content = <MainMenu/>;
        else if (dialog.content === "saveMenu")
            content = <SaveMenu action="save"/>;
        else if (dialog.content === "loadMenu")
            content = <SaveMenu action="load"/>;
        else if (dialog.content === "wifeStat") {
            content = <WifeStat/>;
        }
        else content = <div/>

        return (
            <div style={style}>
                <button className="dialog-close-btn" onClick={close}>X</button>
                {content}
            </div>
        )
    };

    return (
        <div className="dialog-wrapper">
            <DialogComponent
                width="90%"
                target='#dialog-target'
                isModal={true}
                visible={dialog.content !== null}
                closeOnEscape={true}
                zindex={1000}
                close={close}
                beforeOpen={onBeforeOpen}
            >
                {getContent()}
            </DialogComponent>
        </div>
    );
};

export default Dialog;